import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-554d21d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tip"
}
const _hoisted_2 = { class: "tip-title flex-ter" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { style: {"transform":"translateY(10px)"} }
const _hoisted_5 = { style: {"transform":"translateY(-10px)"} }

import { ref, useSlots, computed } from 'vue'
import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: {
    content: { type: String, required: false },
    html: { type: String, required: false },
    options: { type: null, required: false }
  },
  setup(__props: any) {

const props = __props as {content?:string, html?:string, options?:any}


const slots = useSlots()

const yes = computed(() => !!(props.content || props.html || slots.content))

const options = ref({
  effect: 'light',
  'hide-after': 40,
  'show-after': 100,
  placement: 'top',
  ...props.options
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_unref(yes))
    ? (_openBlock(), _createBlock(_component_el_tooltip, _normalizeProps(_mergeProps({ key: 0 }, options.value)), {
        content: _withCtx(() => [
          (__props.content)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(__props.content)), 1)
              ]))
            : (__props.html)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  innerHTML: __props.html
                }, null, 8, _hoisted_3))
              : _renderSlot(_ctx.$slots, "content", { key: 2 })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ])
        ]),
        _: 3
      }, 16))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})